<template>
 <div class="container">
    <div class="card">
      <div class="Mycontent">
        <div class="border border-primary mb-1 p-1 rounded">{{ membershipPlan.title }}</div>
        <div class="img" :style="count>10?'border: 10px solid rgba(10,187,135,.75);':'border: 10px solid rgba(255,0,0,.75);'"><span class="text-center">{{ count }}</span></div>
        <div class="cardContent">
          <h3>روز از اشتراک  شما باقی مانده<br><span v-if="membershipPlan.endDateUtc"><strong>تاریخ پایان : </strong>{{ membershipPlan.endDateUtc | moment }}</span></h3>
        </div>
      </div>
      <ul class="sci">
        <li style="--i:1">
          <slot></slot>
        </li>
    </ul>
    </div>
  </div>
</template>

<script>
export default {
    props:{
        count:{
            type:Number,
            default:0
        },
        membershipPlan:{
            type:Object,
            default:{}
        },
    },
}
</script>

<style lang="scss" scoped>
$colors: (
  one:     #990033,
  two:     #161623,
  
  negro:  #020202,
  blanco: #000000,
  sombra: #000000
);

@function color($color-name) {
    @return map-get($colors, $color-name);
}

@mixin displayFlex($justify,$align,$direction) {
    display: flex;
    justify-content: $justify;
    align-items: $align;
    flex-direction: $direction;
}

@keyframes colorful{
  0% {
    filter: hue-rotate(0deg);
  }
  100% {
    filter: hue-rotate(360deg);
  }
}

*,
*::before,
*::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  text-decoration: none;
  list-style: none;
  outline: none;
  appearance: none;
  border-style: none;
  color: color(blanco);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

html,
body {
  width: 100%;
  height: 100%;
  background: color(two);

  /*scrollbar-width: none;
  overflow: hidden;

  &::-webkit-scrollbar {
    width: 0;
  }*/
}

body {
  position: relative;
  overflow: hidden;
  @include displayFlex(center, center, column);
  padding: 2em;
  
  &::-webkit-scrollbar {
    background: color(negro);
    width: 10px;
  }
  &::-webkit-scrollbar-track {
    background: color(negro);
  }
  &::-webkit-scrollbar-thumb {
    background: color(blanco);
    border-radius: 1px;
  }
  
  &::before {
      content: '';
      position: absolute;
      top: 0; left: 0;
      width: 100%; height: 100%;
      background: linear-gradient(#f00, #f0f);
      clip-path: circle(30% at right 70%);
    }
  &::after {
      content: '';
      position: absolute;
      top: 0; left: 0;
      width: 100%; height: 100%;
      background: linear-gradient(#2196f3, #e91e63);
      clip-path: circle(20% at 10% 10%);
    }
  
  .container {
    position: relative;
    z-index: 1;
    @include displayFlex(center, center, row);
    flex-wrap: wrap;
    padding: 1em;
    
    .card {
      position: relative;
      width: 200px;
      height: 300px;
      margin: 1em;
      background: rgba(255,255,255,0.05);
      box-shadow: 0 15px 35px rgba(0,0,0,.2);
      border-radius: 15px;
      @include displayFlex(center, center, column);
      backdrop-filter: blur(90px);
      
      border: solid 2px transparent;
      background-clip: padding-box;
      box-shadow: 0px 10px 10px rgba(46, 54, 68, 0.15);
      
      .Mycontent {
        position: relative;
        @include displayFlex(center, center, column);
        opacity: 0.5;
        transition: 0.5s;
        
        .img {
          position: relative;
          width: 150px; height: 150px;
          border-radius: 50%;
          overflow: hidden;

          
          span {
            font-size: 50px;
            position: absolute;
            top: 10px; left: 0;
            width: 100%; height: 100%;
            object-fit: cover;
            line-height: 120px;
          }
        }
        
        .cardContent {
          h3 {
            color: rgb(0, 0, 0);
            text-transform: uppercase;
            font-weight: 500;
            font-size: 16px;
            text-align: center;
            margin: 20px 0 10px;
            line-height: 1.1em;
            
            span {
              font-size: 12px;
              font-weight: 300;
              text-transform: initial;
            }
          }
        }
      }
      
      .sci {
        padding-left:0pc;
        position: absolute;
        bottom: 20px;
        @include displayFlex(center, center, row);
        
        li {
          margin: 0 10px;
          transform: translateY(40px);
          opacity: 0;
          transition: 0.5s;
          transition-delay: calc(0.1s * var(--i));
          
          a {
            font-size: 15px;
          }
        }
      }
      
      &:hover .Mycontent {
        opacity: 1;
        transform: translateY(-20px);
      }
      
      &:hover .sci li {
        transform: translateY(0px);
        opacity: 1;
      }
    }
  }
}
</style>
